<div class="row my-0" *ngIf="beneficiary">
  <div class="col px-0">
    <div class="card border-0">
      <div class="card-header mx-0 px-2">
        <div class="row">
          <div class="col-6 text-end text-muted pe-4 pb-2 border-end">N° Insertis</div>
          <div class="col-6 ps-4">
            {{ beneficiary.insertisId ? beneficiary.insertisId : 'Inconnu' }}
          </div>
        </div>
        <div class="row" *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION+', 'DIRECTION', 'TERRITORY', 'MMIE']">
          <div class="col-6 text-end text-muted pe-4 pb-2 border-end">N° CAF/MSA</div>
          <div class="col-6 ps-4">
            {{ beneficiary.recipientNumber ? beneficiary.recipientNumber : 'Inconnu' }}
          </div>
        </div>
        <div class="row">
          <div class="col-6 text-end text-muted pe-4 pb-2 border-end">Âge</div>
          <div class="col-6 ps-4">
            {{ age ? age + ' ans' : 'Inconnu' }}
          </div>
        </div>

        <div class="row" *appOnlyGroups="['ADMIN']">
          <div class="col-6 text-end text-muted pe-4 pb-2 border-end">N° IODAS</div>
          <div class="col-6 ps-4">
            {{ beneficiary.iodasNumber }}
          </div>
        </div>
      </div>
      <div class="card-body pt-3">
        <div
          class="d-flex flex-row mb-2"
          *ngIf="
            beneficiary.residentialAddress?.address || beneficiary.residentialAddress?.additionalAddress || beneficiary.residentialAddress?.postalCode
          "
        >
          <div class="mx-4 ms-lg-0 me-lg-3 text-primary"><fa-icon icon="map-marker-alt"></fa-icon></div>
          <div>
            <p class="mb-0" *ngIf="beneficiary.residentialAddress?.address">
              {{ beneficiary.residentialAddress?.address }}
            </p>
            <p class="mb-0" *ngIf="beneficiary.residentialAddress?.additionalAddress">
              {{ beneficiary.residentialAddress?.additionalAddress }}
            </p>
            <p class="mb-0" *ngIf="beneficiary.residentialAddress?.postalCode || beneficiary.residentialAddress?.city">
              {{ beneficiary.residentialAddress?.postalCode }} {{ beneficiary.residentialAddress?.city }}
            </p>
          </div>
        </div>
        <div class="d-flex flex-row mb-2" *ngIf="beneficiary.emailAddress">
          <div class="mx-4 ms-lg-0 me-lg-3 text-primary"><fa-icon icon="envelope"></fa-icon></div>
          <div>
            <a
              href="mailto:{{ beneficiary.emailAddress | lowercase }}"
              (click)="openModal($event)"
              ngbPopover="Message électronique à {{ (beneficiary.firstName ? beneficiary.firstName + ' ' : '') + beneficiary.usualName }}"
              [openDelay]="300"
              [closeDelay]="300"
              triggers="mouseenter:mouseleave"
              >{{ beneficiary.emailAddress | lowercase }}</a
            >
          </div>
        </div>
        <div class="d-flex flex-row mb-2" *ngIf="beneficiary.cellPhoneNumber">
          <div class="mx-4 ms-lg-0 me-lg-3 text-primary"><fa-icon icon="mobile-alt"></fa-icon></div>
          <div *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION+', 'DIRECTION', 'TERRITORY', 'MMIE']">
            <a
              href="tel:{{ beneficiary.cellPhoneNumber }}"
              (click)="openSmsModal($event)"
              ngbPopover="Message SMS à {{ (beneficiary.firstName ? beneficiary.firstName + ' ' : '') + beneficiary.usualName }}"
              [openDelay]="300"
              [closeDelay]="300"
              triggers="mouseenter:mouseleave"
              >{{ beneficiary.cellPhoneNumber | phone }}</a
            >
          </div>
          <div *appOnlyGroups="['RECEPTION']">
            <span>{{ beneficiary.cellPhoneNumber | phone }}</span>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <p *ngIf="beneficiary.support?.supportType?.label">
          <span class="text-muted">Accompagnement :</span>
          <span>
            {{ beneficiary.support?.supportType?.label }}
          </span>
        </p>
        <p *ngIf="beneficiary.status">
          <span class="text-muted">Statut :</span>
          <span>
            {{ folderStatus.get($folderStatus(beneficiary.status)) }}
          </span>
        </p>
        <p *ngIf="beneficiary.orientation">
          <span class="text-muted">Structure :</span>
          <span>
            {{ beneficiary.orientation.structure.label }}
          </span>
        </p>
        <p *ngIf="currentReferent">
          <span class="text-muted">Référent :</span>
          <span>
            {{ currentReferent?.user.name }}
          </span>
        </p>
        <p *ngIf="beneficiary.lastDateInterview">
          <span class="text-muted">Dernier contact :</span>
          <span>
            {{ beneficiary.lastDateInterview | date: 'dd/MM/yyyy' }}
          </span>
        </p>
      </div>

      <div class="d-grid card-footer px-2 pt-3">
        <div class="btn-group col-12">
          <button
            type="button"
            class="btn btn-primary mt-2"
            *ngIf="page != 'beneficiaryDetailPage'"
            [routerLink]="['/beneficiaries', beneficiary.id, 'details', 'personaldata']"
          >
            Fiche du bénéficiaire
          </button>
        </div>
        <div class="btn-group col-12">
          <button
            type="button"
            class="btn btn-primary mt-2"
            *ngIf="page != 'beneficiaryFolderPage'"
            [routerLink]="['/beneficiaries', beneficiary.id, 'folder', 'interviews']"
          >
            Parcours du bénéficiaire
          </button>
        </div>
        <ng-container *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION+']">
          <div class="btn-group col-12" *ngIf="page != 'beneficiaryRsjPage'">
            <div *hasPermission="'RSJ_CAN_ACCESS'; context: 'BENEFICIARY_RSJ'" class="w-100">
              <button
                type="button"
                class="btn btn-primary w-100 mt-2"
                [routerLink]="['/beneficiaries', beneficiary.id, 'rsj', 'rsj-personaldata']"
                *ngIf="beneficiary.rsjId && beneficiariesService.accessMode?.value !== 'participant'"
              >
                Parcours RSJ
              </button>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
<div class="row mt-2">
  <div class="col px-0">
    <div class="btn-group-vertical btn-group col-12" role="group">
      <h5 class="text-secondary ps-4">Actions sur le dossier</h5>
      <button
        class="btn btn-light rounded-0 border-bottom border-top d-flex justify-content-center"
        (click)="openModal()"
        [disabled]="!beneficiary?.emailAddress"
      >
        <fa-icon class="text-primary" [icon]="['far', 'envelope']"></fa-icon>
        <span class="ms-3 d-none d-md-block">Message électronique</span>
      </button>
      <button
        class="btn btn-light rounded-0 border-bottom border-top d-flex justify-content-center"
        (click)="openSmsModal()"
        [disabled]="!beneficiary?.cellPhoneNumber"
        *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION+', 'DIRECTION', 'TERRITORY', 'MMIE']"
      >
        <fa-icon class="text-primary" [icon]="['far', 'comment']"></fa-icon>
        <span class="ms-3 d-none d-md-block">Message SMS</span>
      </button>
      <button
        class="btn btn-light rounded-0 border-bottom border-top d-flex justify-content-center"
        (click)="openSummaryExportModal()"
        *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION+', 'DIRECTION', 'TERRITORY', 'MMIE']"
      >
        <fa-icon class="text-primary" [icon]="['fas', 'download']"></fa-icon>
        <span class="ms-3 d-none d-md-block">Fiche récapitulative</span>
      </button>
    </div>
  </div>
</div>
